import React, { useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import useClickOutside from '../../hooks/useClickOutside';
import type { MenuItem } from './types/navigation';

interface NavigationSubmenuProps {
  label: string;
  icon: MenuItem['icon'];
  items: MenuItem['submenu'];
}

const NavigationSubmenu: React.FC<NavigationSubmenuProps> = ({ label, icon: Icon, items = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useClickOutside(menuRef, () => setIsOpen(false));

  return (
    <div ref={menuRef} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center space-x-1 px-3 py-2 rounded-md text-sm font-medium transition-colors
          ${isOpen ? 'text-brand bg-brand/10' : 'text-content-secondary hover:text-content-primary hover:bg-background'}`}
      >
        {Icon && <Icon className="w-5 h-5" />}
        <span>{label}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute z-50 left-0 mt-1 w-48 bg-background-secondary rounded-md shadow-lg py-1 border border-gray-800">
          {items?.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-2 text-sm ${
                  isActive
                    ? 'text-brand bg-brand/10'
                    : 'text-content-secondary hover:text-content-primary hover:bg-background'
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
};

export default NavigationSubmenu;